import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import CheckBeforeHiring from "@/pages/CheckBeforeHiring";
import RaiseDispute from "@/pages/RaiseDispute";
import ResolutionCentre from "@/pages/ResolutionCentre";
import GovernmentGuidelines from "@/pages/GovernmentGuidelines";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Support from "@/pages/Support";
import PublicFeed from "@/pages/PublicFeed";
import VendorDiscovery from "@/pages/VendorDiscovery";
import VendorDetail from "@/pages/VendorDetail";
import VendorApply from "@/pages/VendorApply";
import DiscoveryAdmin from "@/pages/DiscoveryAdmin";
import PublicDisputeDetail from "@/pages/PublicDisputeDetail";
import FileComplaint from "@/pages/FileComplaint";
import ComplaintDetail from "@/pages/ComplaintDetail";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import LegalPage from "@/pages/LegalPage";
import AboutUs from "@/pages/AboutUs";
import Faq from "@/pages/Faq";
import Pricing from "@/pages/Pricing";
import Reviews from "@/pages/Reviews";
import FeaturedVendors from "@/pages/FeaturedVendors";
import VerifiedProfiles from "@/pages/VerifiedProfiles";
import GovernmentHelp from "@/pages/GovernmentHelp";
import Lawyers from "@/pages/Lawyers";
import FileComplaintLanding from "@/pages/FileComplaintLanding";
import NotFound from "@/pages/NotFound";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
    
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/consumer-services" element={<Services />} />
              <Route path="/check-before-hiring" element={<CheckBeforeHiring />} />
              <Route path="/raise-dispute" element={<RaiseDispute />} />
              <Route path="/resolution-centre" element={<ResolutionCentre />} />
              <Route path="/government-guidelines" element={<GovernmentGuidelines />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/contact-us" element={<Contact />} />
              <Route path="/support" element={<Support />} />

              {/* SEO sitemap pages */}
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/check-before-you-trust" element={<CheckBeforeHiring />} />
              <Route path="/file-a-complaint" element={<FileComplaintLanding />} />
              <Route path="/resolve-a-dispute" element={<ResolutionCentre />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/featured-vendors" element={<FeaturedVendors />} />
              <Route path="/verified-profiles" element={<VerifiedProfiles />} />
              <Route path="/government-help" element={<GovernmentHelp />} />
              <Route path="/government-help/:topic" element={<GovernmentHelp />} />
              <Route path="/lawyers" element={<Lawyers />} />
              <Route path="/lawyers/:city" element={<Lawyers />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/faq" element={<Faq />} />

              {/* Legal pages (SEO-friendly URLs) */}
              <Route path="/terms-of-service" element={<LegalPage slug="terms-of-service" />} />
              <Route path="/privacy-policy" element={<LegalPage slug="privacy-policy" />} />
              <Route path="/complaint-policy" element={<LegalPage slug="complaint-policy" />} />
              <Route path="/evidence-policy" element={<LegalPage slug="evidence-policy" />} />
              <Route path="/community-guidelines" element={<LegalPage slug="community-guidelines" />} />
              <Route path="/moderation-appeals" element={<LegalPage slug="moderation-appeals" />} />
              <Route path="/correction-request" element={<LegalPage slug="correction-request" />} />
              <Route path="/data-deletion" element={<LegalPage slug="data-deletion" />} />
              <Route path="/disclaimer" element={<LegalPage slug="disclaimer" />} />
              <Route path="/accessibility" element={<LegalPage slug="accessibility" />} />
              <Route path="/sitemap" element={<LegalPage slug="sitemap" />} />
              <Route path="/disputes" element={<PublicFeed />} />
              <Route path="/vendors" element={<VendorDiscovery />} />
              <Route path="/vendors/list-your-business" element={<VendorApply />} />
              <Route path="/vendors/vendor/:slug" element={<VendorDetail />} />
              <Route path="/vendors/:categorySlug" element={<VendorDiscovery />} />
              <Route path="/vendors/:categorySlug/:subSlug" element={<VendorDiscovery />} />
              <Route path="/dispute/:id" element={<PublicDisputeDetail />} />
              <Route path="/legal/:page" element={<LegalPage />} />
              <Route path="/file-complaint" element={<ProtectedRoute><FileComplaint /></ProtectedRoute>} />
              <Route path="/complaint/:id" element={<ProtectedRoute><ComplaintDetail /></ProtectedRoute>} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute admin><Admin /></ProtectedRoute>} />
              <Route path="/admin/discovery" element={<ProtectedRoute admin><DiscoveryAdmin /></ProtectedRoute>} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
